module.exports = __webpack_public_path__ + "img/m-icon2.92e59253.png";